<!--房源管理-->
<template>
  <div class="houseInfoIndexClass">
    <div>
      <nav-com activeIndex="10"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="房源标题： ">
                  <el-input
                    placeholder="请输入房源标题..."
                    v-model="search.TITLE"
                  ></el-input>
                  <el-input
                    placeholder="请输入小区名称..."
                    v-model="search.COMMUNITYNAME"
                    style="margin-left: 10px"
                  ></el-input>
                  <el-select
                    v-model="search.STATUSID"
                    placeholder="请选择房源状态"
                    clearable
                    style="margin-left: 10px; width: 150px"
                  >
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="未审核" value="1"></el-option>
                    <el-option label="已审核评级" value="2"></el-option>
                    <el-option label="驳回" value="3"></el-option>
                    <el-option label="房源签约" value="4"></el-option>
                    <el-option label="房源结佣" value="5"></el-option>
                    <el-option label="装修中" value="6"></el-option>
                    <el-option label="待验收" value="7"></el-option>
                    <el-option label="加配饰" value="8"></el-option>
                    <el-option label="待发布" value="9"></el-option>
                    <el-option label="热卖中" value="10"></el-option>
                    <el-option label="成交" value="11"></el-option>
                    <el-option label="结款" value="12"></el-option>
                  </el-select>
                  <!-- 上架状态筛选已隐藏
                  <el-select
                    v-model="search.ISSHOW"
                    placeholder="请选择上架状态"
                    clearable
                    style="margin-left: 10px; width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已上架" value="1"></el-option>
                    <el-option label="未上架" value="0"></el-option>
                  </el-select>
                  -->
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="HOUSEID"
            label="房源ID"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="TITLE"
            label="标题"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="COMMUNITYNAME"
            label="小区名称"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="ADDRESS"
            label="地址"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="TYPE"
            label="房屋类型"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="AREA"
            label="平米"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="PRICE"
            label="房源总价(元)"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="ORIENTATION"
            label="朝向"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="BUILDYEAR"
            label="建造年代"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="FLOOR"
            label="楼层"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="TOTALFLOOR"
            label="总楼层"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="ROOMS"
            label="卧室"
            width="70"
          ></el-table-column>
          <el-table-column
            prop="LIVINGROOMS"
            label="客厅"
            width="70"
          ></el-table-column>
          <el-table-column
            prop="BATHROOMS"
            label="卫生间"
            width="80"
          ></el-table-column>
          <el-table-column label="电梯" width="70">
            <template slot-scope="scope">
              {{ scope.row.ELEVATOR === "1" ? "有" : "无" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="BUILDING_TYPE"
            label="建筑类型"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="VIEWS"
            label="浏览次数"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="SHARES"
            label="分享次数"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="VISITS"
            label="带看次数"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="INQUIRIES"
            label="约谈次数"
            width="100"
          ></el-table-column>
          <el-table-column label="房源状态" width="120" fixed="right">
            <template slot-scope="scope">
              {{ getStatusText(scope.row.STATUSID) }}
            </template>
          </el-table-column>
          <el-table-column label="上架状态" width="100" fixed="right">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.STATUSID === '10' && scope.row.ISSHOW === '1'
                    ? 'success'
                    : 'info'
                "
              >
                {{
                  scope.row.STATUSID === "10" && scope.row.ISSHOW === "1"
                    ? "已上架"
                    : "未上架"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="顺序号" width="120" fixed="right">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.SHOWNUM"
                size="small"
                @blur="updateShowNum(scope.row)"
                placeholder="顺序号"
                :disabled="scope.row.STATUSID !== '10'"
                :style="
                  scope.row.STATUSID !== '10'
                    ? 'opacity: 0.5; cursor: not-allowed;'
                    : ''
                "
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="openEditDialog(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.ISSHOW === '0'"
                type="success"
                size="small"
                @click="toggleShow(scope.row, '1')"
                :disabled="scope.row.STATUSID !== '10'"
                :style="
                  scope.row.STATUSID !== '10'
                    ? 'opacity: 0.5; cursor: not-allowed;'
                    : ''
                "
              >
                上架
              </el-button>
              <el-button
                v-else
                type="warning"
                size="small"
                @click="toggleShow(scope.row, '0')"
                :disabled="scope.row.STATUSID !== '10'"
                :style="
                  scope.row.STATUSID !== '10'
                    ? 'opacity: 0.5; cursor: not-allowed;'
                    : ''
                "
              >
                下架
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->
    </div>

    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑房源信息"
      :visible.sync="editDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="房源标题">
          <el-input
            v-model="editForm.TITLE"
            placeholder="请输入房源标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="户型图">
          <div class="image-upload-container">
            <div
              class="image-list"
              v-if="
                editForm.floorPlanImages && editForm.floorPlanImages.length > 0
              "
            >
              <div
                class="image-item"
                v-for="(img, index) in editForm.floorPlanImages"
                :key="'floor-' + index"
              >
                <img :src="img" alt="户型图" />
                <div class="image-actions">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click="deleteImage('floorPlan', index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-upload
              class="upload-demo"
              :action="uploadImgUrl"
              :on-success="
                (response, file, fileList) =>
                  handleUploadSuccess(response, file, fileList, 'floorPlan')
              "
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
            >
              <el-button size="small" type="primary">上传户型图</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过5MB
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="实勘图">
          <div class="image-upload-container">
            <div
              class="image-list"
              v-if="editForm.surveyImages && editForm.surveyImages.length > 0"
            >
              <div
                class="image-item"
                v-for="(img, index) in editForm.surveyImages"
                :key="'survey-' + index"
              >
                <img :src="img" alt="实勘图" />
                <div class="image-actions">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click="deleteImage('survey', index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-upload
              class="upload-demo"
              :action="uploadImgUrl"
              :on-success="
                (response, file, fileList) =>
                  handleUploadSuccess(response, file, fileList, 'survey')
              "
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
            >
              <el-button size="small" type="primary">上传实勘图</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过5MB
              </div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveImages">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "HouseInfoIndex",
  components: { NavCom, allParam },
  data() {
    return {
      rows: [],
      search: {
        TITLE: "",
        COMMUNITYNAME: "",
        STATUSID: "",
        ISSHOW: ""
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [50, 100, 1000],
        pageSize: 50, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableData: [],
      // 编辑对话框
      editDialogVisible: false,
      editForm: {
        HOUSEID: "",
        TITLE: "",
        floorPlanImages: [],
        surveyImages: []
      },
      uploadImgUrl: "" // 上传接口地址
    };
  },
  created() {
    this.op = "adminHouseInfoGl";
    this.utilPost = this.$util.handler;
    // 设置上传地址
    this.uploadImgUrl = allParam.uploadImgUrl;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      console.log("🔍 发送的搜索参数:", JSON.stringify(this.search, null, 2));
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
      });
    },
    /**分页方法 结束 */

    // 获取房源状态文本
    getStatusText(statusId) {
      const statusMap = {
        "1": "未审核",
        "2": "已审核评级",
        "3": "驳回",
        "4": "房源签约",
        "5": "房源结佣",
        "6": "装修中",
        "7": "待验收",
        "8": "加配饰",
        "9": "待发布",
        "10": "热卖中",
        "11": "成交",
        "12": "结款"
      };
      return statusMap[statusId] || "未知状态";
    },
    // 上架/下架操作
    toggleShow(row, isShow) {
      // 只有热卖中状态才能操作
      if (row.STATUSID !== "10") {
        this.$message.warning("只有热卖中状态的房源才能进行上架/下架操作");
        return;
      }
      const action = isShow === "1" ? "上架" : "下架";
      if (!confirm(`确定要${action}该房源吗？`)) {
        return;
      }

      var busData = {
        HOUSEID: row.HOUSEID,
        ISSHOW: isShow
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "toggleShow"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.$message.success(`${action}成功`);
        this.mainLoad();
      });
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.editForm.HOUSEID = row.HOUSEID;
      this.editForm.TITLE = row.TITLE;

      // 解析图片数据（从逗号分隔的字符串转为数组）
      this.editForm.floorPlanImages = this.parseImages(row.APARTMENT_IMAGES);
      this.editForm.surveyImages = this.parseImages(row.SURVEY_IMAGES);

      this.editDialogVisible = true;
    },

    // 解析图片字符串为数组
    parseImages(imageStr) {
      if (!imageStr || imageStr.trim() === "") {
        return [];
      }
      return imageStr
        .split(",")
        .map(img => img.trim())
        .filter(img => img.length > 0);
    },

    // 上传前验证
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传的图片大小不能超过 5MB!");
        return false;
      }
      return isJPG && isLt5M;
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList, type) {
      console.log("图片上传返回数据：", response);
      if (response.isSuccess) {
        // 使用URL字段作为图片地址
        const imageUrl =
          response.content.url || response.content.filePath || "";
        if (imageUrl) {
          if (type === "floorPlan") {
            this.editForm.floorPlanImages.push(imageUrl);
          } else if (type === "survey") {
            this.editForm.surveyImages.push(imageUrl);
          }
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传成功但未获取到图片地址");
        }
      } else {
        this.$message.error("上传失败：" + (response.msg || "未知错误"));
      }
    },

    // 上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error("上传失败: " + err.message);
    },

    // 删除图片
    deleteImage(type, index) {
      if (!confirm("确定要删除这张图片吗？")) {
        return;
      }
      if (type === "floorPlan") {
        this.editForm.floorPlanImages.splice(index, 1);
      } else if (type === "survey") {
        this.editForm.surveyImages.splice(index, 1);
      }
      this.$message.success("删除成功");
    },

    // 保存图片及房源标题
    saveImages() {
      var busData = {
        HOUSEID: this.editForm.HOUSEID,
        TITLE: this.editForm.TITLE,
        APARTMENT_IMAGES: this.editForm.floorPlanImages.join(","),
        SURVEY_IMAGES: this.editForm.surveyImages.join(",")
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "updateHouseImages"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          this.$message.error(data.msg || "保存失败");
          return;
        }
        this.$message.success("保存成功");
        this.editDialogVisible = false;
        this.mainLoad();
      });
    },

    // 更新顺序号
    updateShowNum(row) {
      // 只有热卖中状态才能操作
      if (row.STATUSID !== "10") {
        this.$message.warning("只有热卖中状态的房源才能修改顺序号");
        this.mainLoad();
        return;
      }
      if (!row.SHOWNUM || row.SHOWNUM.trim() === "") {
        this.$message.warning("顺序号不能为空");
        this.mainLoad();
        return;
      }

      var busData = {
        HOUSEID: row.HOUSEID,
        SHOWNUM: row.SHOWNUM
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "updateShowNum"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          this.mainLoad();
          return;
        }
        this.$message.success("顺序号更新成功");
        this.mainLoad();
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.houseInfoIndexClass {
  .searchMainClass .el-input {
    width: 200px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }

  // 图片上传样式
  .image-upload-container {
    .image-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 15px;

      .image-item {
        position: relative;
        width: 150px;
        height: 150px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-actions {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.6);
          padding: 5px;
          text-align: center;
          opacity: 0;
          transition: opacity 0.3s;
        }

        &:hover .image-actions {
          opacity: 1;
        }
      }
    }

    .el-upload__tip {
      margin-top: 5px;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/houseInfo/HouseInfoIndex.vue